import service from "@/utils/http.js";
//获取domain
export function getDomain(host) {
    return service({
        url: `/api/blade-user/app/getTeanantId?domain=${host}`,
        method: 'get',
    })
}

//字典查询
export function getDictionary(code) {
    return service({
        url: `/api/blade-system/dict/dictionary?code=${code}`,
        method: 'get',
    })
}

